(function () {
  'use strict';
  const bootstrap = window.__partifyAddOnStyles;
  const variant = 'A';
  let config = null;
  let session = null;
  let stylesReady = null;
  const numericId = value => String(value || '').split('/').pop();
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char]));
  const normalize = value => String(value || '').replace(/[^a-z0-9]/gi, '').toLowerCase();
  const root = () => window.Shopify?.routes?.root || '/';
  const text = key => String(config?.copy?.[key] || '');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(Number(cents || 0) / 100);
  const productUrl = handle => root() + 'products/' + encodeURIComponent(handle || '');
  const active = () => !!config;

  function loadStyles() {
    if (stylesReady) return stylesReady;
    stylesReady = new Promise(resolve => {
      const css = document.createElement('link');
      css.id = 'pf-addon-styles-css'; css.rel = 'stylesheet'; css.href = config.stylesheet;
      css.onload = resolve; css.onerror = resolve;
      document.head.appendChild(css);
      window.setTimeout(resolve, 2000);
    });
    return stylesReady;
  }

  function track(event, properties) {
    try {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: 'addon_styles_' + event, properties: { variant, product_id: config?.product?.id, category: session?.isPaint ? 'touchup' : 'part', ...properties } });
    } catch (_) {}
  }

  async function request(path, payload) {
    const writing = payload !== undefined;
    let response;
    try {
      response = await fetch(root() + path, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: AbortSignal.timeout(writing ? 12000 : 8000),
        ...(writing ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) } : {}),
      });
    } catch (error) {
      error.uncertain = writing;
      throw error;
    }
    if (!response.ok) {
      const error = new Error(text('retry'));
      error.rejected = true;
      error.uncertain = writing;
      throw error;
    }
    try {
      return await response.json();
    } catch (error) {
      error.uncertain = writing;
      throw error;
    }
  }

  function navigate(path) {
    if (typeof window.__PARTIFY_ADDON_STYLES_NAVIGATE === 'function') window.__PARTIFY_ADDON_STYLES_NAVIGATE(path);
    else window.location.assign(path);
  }

  function media(image, title, className) {
    return '<div class="' + className + '">' + (image ? '<img src="' + escape(image) + '" alt="' + escape(title) + '" width="360" height="280" loading="eager">' : '') + '</div>';
  }

  function readContext(options) {
    const id = numericId(options.items?.[0]?.id || document.querySelector('#product-form [name="id"]')?.value);
    const properties = { ...(options.items?.[0]?.properties || {}) };
    const summary = window.__partifyGetAddOnStyleCasperSummary?.() || window.__partifyGetCasperAddOnSummary?.() || {};
    return {
      id, properties,
      addedQuantity: Number(options.items?.[0]?.quantity) || 1,
      related: window.__partifyGetAddOnStyleRelatedParts?.() || [],
      clipEligible: summary.clip ? summary.clip.ready === true : config.product.clipEligible,
      paint: summary.paint?.ready ? { ...summary.paint, properties: window.__partifyGetCasperPaintLineProperties?.() || {} } : null,
      entries: Object.entries(window.__touchupSizeMap || {}).flatMap(([code, entries]) => entries.map(entry => ({ ...entry, code }))),
    };
  }

  async function availableProduct(candidate) {
    if (!candidate.handle || !candidate.variantId) return null;
    try {
      const product = await request('products/' + encodeURIComponent(candidate.handle) + '.js');
      const item = product.variants?.find(entry => String(entry.id) === numericId(candidate.variantId));
      if (!item?.available || !Number.isSafeInteger(item.price) || item.price < 0) return null;
      return { ...candidate, variantId: String(item.id), priceCents: item.price, title: candidate.title || product.title, image: candidate.image || product.featured_image || '', sku: item.sku || '', available: true };
    } catch (_) {
      return null;
    }
  }

  function upgradeCandidates(current) {
    const main = current.main;
    const code = main.properties?.['Touch-Up Color'];
    const format = main.properties?.['Kit Format'];
    const tier = normalize(main.properties?.['Kit Package']);
    const tiers = ['paintonly', 'essential', 'preferred', 'complete'];
    if (!code || !format || main.quantity !== current.context.addedQuantity) return [];
    if (/match.*vin|^\.?vin$/i.test(code) && !/^[A-HJ-NPR-Z0-9]{17}$/.test(main.properties?.VIN || '')) return [];
    const entries = current.context.entries.filter(entry => entry.available === true && normalize(entry.code) === normalize(code) && normalize(entry.size) === normalize(format) && tiers.indexOf(normalize(entry.packageName)) > tiers.indexOf(tier));
    const chosen = [];
    const essential = entries.find(entry => normalize(entry.packageName) === 'essential');
    const full = entries.find(entry => normalize(entry.packageName) === 'complete') || entries.find(entry => normalize(entry.packageName) === 'preferred');
    [essential, full].filter(Boolean).forEach(entry => {
      if (chosen.some(candidate => candidate.variantId === numericId(entry.id))) return;
      const priceCents = Math.round(Number(String(entry.price).replace(/,/g, '')) * 100);
      if (!Number.isSafeInteger(priceCents) || priceCents <= main.price) return;
      const image = window.PartifyTouchupCartImages?.resolve({ properties: { 'Kit Format': format, 'Kit Package': entry.packageName } }) || entry.productImage;
      chosen.push({ kind: 'upgrade', variantId: numericId(entry.id), handle: entry.productHandle, title: text('upgrade') + ' ' + (text(normalize(entry.packageName)) || entry.packageName), image, priceCents, description: text('upgrade_description'), quantity: main.quantity, packageName: entry.packageName, productTitle: entry.productTitle, code: entry.code, format: entry.size });
    });
    return chosen;
  }

  async function recommendations(current) {
    const candidates = [];
    const catalog = config.products || {};
    if (current.isPaint) {
      if (normalize(current.main.properties?.['Kit Format']) === 'aerosol') candidates.push({ ...catalog.trigger, kind: 'trigger', description: text('trigger_description') });
      if (['halfpint', 'pint', 'quart', 'gallon'].includes(normalize(current.main.properties?.['Kit Format']))) candidates.push({ ...catalog.sprayGun, kind: 'spray_gun', description: text(catalog.sprayGun?.backorder ? 'spray_gun_backorder_description' : 'spray_gun_description') });
      candidates.push(...upgradeCandidates(current));
      candidates.push({ ...catalog.towels, kind: 'towels', description: text('towels_description') });
    } else {
      if (current.context.clipEligible) candidates.push({ ...catalog.clip, kind: 'clip', title: text('clip_title'), description: text('clip_description') });
      current.context.related.filter(item => /bumper/i.test(item.title) && /support|bracket|retainer/i.test(item.title)).sort((a, b) => Number(/upper/i.test(b.title)) - Number(/upper/i.test(a.title))).slice(0, 2).forEach(item => candidates.push({ ...item, variantId: numericId(item.variantId), kind: 'support', description: text('support_description'), quantity: current.context.addedQuantity }));
      if (current.context.paint) candidates.push({ ...current.context.paint, kind: 'paint', title: window.__PARTIFY_BUNDLE?.paintName, description: text('paint_description') });
      if (!candidates.length) candidates.push({ ...catalog.towels, kind: 'towels', description: text('towels_description') });
    }
    const unique = candidates.filter((item, index) => item.variantId && candidates.findIndex(other => numericId(other.variantId) === numericId(item.variantId)) === index && !current.cart.items.some(line => String(line.variant_id) === numericId(item.variantId)));
    const available = await Promise.all(unique.map(availableProduct));
    return available.filter(Boolean).filter(item => item.kind !== 'upgrade' || item.priceCents > current.main.price).slice(0, 4).map((item, index) => ({ ...item, key: String(index), quantity: item.quantity || 1, selected: false, committed: false }));
  }

  function delta(item, current) {
    return (item.priceCents - (item.kind === 'upgrade' ? current.main.price : 0)) * item.quantity;
  }

  function mainMarkup(current) {
    const main = current.main;
    const image = window.PartifyTouchupCartImages?.resolve(main) || main.featured_image?.url || main.image || config.product.image;
    const meta = [main.variant_title && main.variant_title !== 'Default Title' ? main.variant_title : '', text('quantity') + ' ' + main.quantity].filter(Boolean).join(' · ');
    return '<article class="pf-extras__main">' + media(image, main.product_title || main.title, 'pf-extras__main-media') +
      '<p class="pf-extras__main-tag">' + escape(text('main_item')) + '</p><h3 class="pf-extras__main-title">' + escape(main.product_title || main.title || config.product.title) + '</h3>' +
      '<p class="pf-extras__main-meta">' + escape(meta) + '</p><strong class="pf-extras__main-price">' + escape(money(main.final_line_price ?? main.line_price ?? main.price * main.quantity)) + '</strong></article>';
  }

  function cardMarkup(item, current) {
    const inputId = 'pf-addon-' + item.key;
    const selection = '<label class="pf-extras__selection" for="' + inputId + '"><input id="' + inputId + '" type="' + (item.kind === 'upgrade' ? 'radio' : 'checkbox') + '" name="' + (item.kind === 'upgrade' ? 'pf-kit-upgrade' : inputId) + '" data-addon-select="' + item.key + '"><span>' + escape(text('add')) + '</span></label>';
    return '<article class="pf-extras__card" data-addon-card="' + item.key + '">' + media(item.image, item.title, 'pf-extras__media') + '<h4 class="pf-extras__title">' + escape(item.title) + '</h4><p class="pf-extras__description">' + escape(item.description) + '</p><strong class="pf-extras__price">+' + escape(money(delta(item, current))) + '</strong><div class="pf-extras__selection">' + selection + '</div><a class="pf-extras__details-link" href="' + escape(productUrl(item.handle)) + '" target="_blank" rel="noopener">' + escape(text('view_product')) + '</a></article>';
  }

  function render(current) {
    const dialog = document.createElement('dialog');
    dialog.className = 'pf-extras';
    dialog.setAttribute('aria-labelledby', 'pf-extras-heading');
    dialog.setAttribute('data-addon-style', variant);
    dialog.innerHTML = '<header class="pf-extras__header"><p class="pf-extras__eyebrow"><span class="pf-extras__check" aria-hidden="true">✓</span>' + escape(text('added')) + '</p><h2 id="pf-extras-heading">' + escape(text('headline_a')) + '</h2><p class="pf-extras__intro">' + escape(text(current.isPaint ? 'intro_paint' : 'intro_parts')) + '</p><button type="button" class="pf-extras__close" data-addon-close aria-label="' + escape(text('close')) + '">×</button></header>' +
      '<div class="pf-extras__body"><div class="pf-extras__layout">' + mainMarkup(current) + '<section class="pf-extras__recommendations" aria-labelledby="pf-extras-section"><h3 class="pf-extras__section-title" id="pf-extras-section">' + escape(text('optional')) + '</h3><div class="pf-extras__cards">' + current.offers.map(item => cardMarkup(item, current)).join('') + '</div></section></div></div>' +
      '<footer class="pf-extras__footer"><div class="pf-extras__totals"><p class="pf-extras__subtotal"><span>' + escape(text('subtotal')) + '</span><strong data-addon-total aria-live="polite"></strong></p><p class="pf-extras__tax">' + escape(text('before_tax')) + '</p></div><div class="pf-extras__actions"><button type="button" class="pf-extras__secondary" data-addon-skip>' + escape(text('skip')) + '</button><button type="button" class="pf-extras__primary" data-addon-continue>' + escape(text('continue')) + '</button></div><p class="pf-extras__notice" data-addon-notice role="status" aria-live="polite"></p><a class="pf-extras__review" href="' + root() + 'cart" data-addon-review hidden>' + escape(text('review_cart')) + '</a></footer>';
    current.dialog = dialog;
    document.body.appendChild(dialog);
    dialog.addEventListener('change', event => {
      const key = event.target.dataset.addonSelect;
      if (key === undefined || current.busy) return;
      const offer = current.offers.find(item => item.key === key);
      if (!offer) return;
      if (offer.kind === 'upgrade') current.offers.filter(item => item.kind === 'upgrade').forEach(item => { item.selected = false; });
      offer.selected = event.target.checked;
      track('selected', { kind: offer.kind, selected: offer.selected, variant_id: offer.variantId });
      refresh(current);
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-addon-close]') || event.target === dialog) close(current);
      if (event.target.closest('[data-addon-skip]') && !current.busy) {
        track('skipped', {});
        navigate(root() + 'cart');
      }
      if (event.target.closest('[data-addon-continue]') && !current.busy) {
        if (current.uncertain) return navigate(root() + 'cart');
        const selected = current.offers.filter(item => item.selected && !item.committed);
        if (!selected.length) {
          track('continue', { extras: current.offers.filter(item => item.committed).length });
          navigate(root() + 'cart');
        } else commit(current, selected).then(ok => { if (ok) navigate(root() + 'cart'); });
      }
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(current); });
    dialog.addEventListener('close', () => { if (session === current) close(current); });
    refresh(current);
    dialog.showModal();
    current.previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('[data-addon-close]').focus();
  }

  function refresh(current) {
    const dialog = current.dialog;
    if (!dialog) return;
    const pending = current.offers.filter(item => item.selected && !item.committed).reduce((sum, item) => sum + delta(item, current), 0);
    dialog.querySelector('[data-addon-total]').textContent = money(current.cart.total_price + pending);
    current.offers.forEach(item => {
      const card = dialog.querySelector('[data-addon-card="' + item.key + '"]');
      card.classList.toggle('is-selected', item.selected || item.committed);
      const check = card.querySelector('input');
      if (check) { check.checked = item.selected || item.committed; check.disabled = current.busy || current.uncertain || item.committed; }
      if (item.kind === 'upgrade' && current.upgraded && !item.committed) card.hidden = true;
    });
    const visibleCount = current.offers.filter(item => !(item.kind === 'upgrade' && current.upgraded && !item.committed)).length;
    dialog.dataset.offerCount = String(visibleCount);
    dialog.style.setProperty('--pe-columns', visibleCount === 3 ? 3 : Math.min(2, visibleCount) || 1);
    dialog.querySelector('[data-addon-continue]').disabled = current.busy;
    dialog.querySelector('[data-addon-continue]').textContent = text(current.busy ? 'adding' : current.uncertain ? 'review_cart' : 'continue');
    dialog.querySelector('[data-addon-skip]').disabled = current.busy;
    dialog.querySelector('[data-addon-skip]').hidden = !current.offers.some(item => item.selected);
    dialog.querySelector('[data-addon-close]').disabled = current.busy;
    if (current.upgraded) {
      const main = dialog.querySelector('.pf-extras__main');
      const holder = document.createElement('div');
      holder.innerHTML = mainMarkup(current);
      main.replaceWith(holder.firstElementChild);
    }
  }

  function close(current) {
    if (current.busy || session !== current) return;
    session = null;
    if (current.dialog?.open) current.dialog.close();
    current.dialog?.remove();
    document.documentElement.style.overflow = current.previousOverflow || '';
    current.options.onClose?.();
    if (current.trigger?.isConnected) current.trigger.focus({ preventScroll: true });
    track('closed', { category: current.isPaint ? 'touchup' : 'part' });
  }

  function propertiesFor(offer, current) {
    let properties = {};
    if (offer.kind === 'upgrade') properties = { ...current.main.properties, 'Kit Package': offer.packageName, 'Kit Product': offer.productTitle };
    else if (offer.kind === 'paint') properties = { ...offer.properties };
    else if (offer.kind === 'support' || offer.kind === 'clip') ['VIN', 'Vehicle', 'EasySearch'].forEach(key => { if (current.main.properties?.[key]) properties[key] = current.main.properties[key]; });
    return { ...properties, _addon_style: variant, _addon_source: offer.kind };
  }

  async function commit(current, offers) {
    if (session !== current || current.busy || current.uncertain) return false;
    current.busy = true;
    refresh(current);
    const notice = current.dialog.querySelector('[data-addon-notice]');
    notice.classList.remove('is-error');
    notice.textContent = text('adding');
    let wrote = false;
    try {
      const cart = await request('cart.js');
      const original = cart.items?.find(line => line.key === current.main.key);
      if (!original || original.quantity !== current.main.quantity || original.price !== current.main.price || JSON.stringify(original.properties || {}) !== JSON.stringify(current.main.properties || {})) throw new Error(text('unavailable'));
      const fresh = await Promise.all(offers.map(availableProduct));
      if (fresh.some(item => !item)) throw new Error(text('unavailable'));
      fresh.forEach((item, index) => {
        if (item.priceCents !== offers[index].priceCents) throw new Error(text('unavailable'));
        if (cart.items.some(line => String(line.variant_id) === item.variantId)) throw new Error(text('already_in_cart'));
        if (item.kind === 'support' && !(window.__partifyGetAddOnStyleRelatedParts?.() || []).some(part => numericId(part.variantId) === item.variantId)) throw new Error(text('unavailable'));
      });
      const items = offers.map(offer => ({ id: Number(offer.variantId), quantity: offer.quantity, properties: propertiesFor(offer, current) }));
      const added = await request('cart/add.js', { items });
      wrote = true;
      if (!Array.isArray(added.items) || items.some(item => !added.items.some(line => String(line.variant_id || line.id) === String(item.id)))) throw Object.assign(new Error(text('uncertain')), { uncertain: true });
      const upgrade = offers.find(item => item.kind === 'upgrade');
      if (upgrade) {
        const replacement = added.items.find(line => String(line.variant_id || line.id) === upgrade.variantId);
        try {
          await request('cart/change.js', { id: current.main.key, quantity: 0 });
        } catch (error) {
          if (error.rejected && replacement?.key) {
            try { await request('cart/change.js', { id: replacement.key, quantity: 0 }); } catch (_) {}
          }
          throw Object.assign(new Error(text('upgrade_failed')), { uncertain: true });
        }
        current.main = { ...replacement, properties: propertiesFor(upgrade, current), price: upgrade.priceCents, quantity: upgrade.quantity };
        current.upgraded = true;
      }
      current.cart = await request('cart.js');
      if (!Array.isArray(current.cart.items) || !Number.isSafeInteger(current.cart.total_price)) throw new Error(text('uncertain'));
      if (upgrade) current.main = current.cart.items.find(line => String(line.variant_id) === upgrade.variantId && line.properties?._addon_style === variant) || current.main;
      offers.forEach(item => { item.committed = true; item.selected = false; track('added', { kind: item.kind, variant_id: item.variantId, quantity: item.quantity, value_cents: delta(item, { ...current, main: original }) }); });
      notice.textContent = text('added_extras');
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: current.cart } }));
      return true;
    } catch (error) {
      current.uncertain = wrote || !!error.uncertain;
      notice.classList.add('is-error');
      notice.textContent = current.uncertain ? text('uncertain') : error.message || text('retry');
      current.dialog.querySelector('[data-addon-review]').hidden = !current.uncertain;
      track('error', { uncertain: current.uncertain });
      return false;
    } finally {
      current.busy = false;
      refresh(current);
    }
  }

  function afterAdd(options = {}) {
    if (!active()) return false;
    if (session) return true;
    const current = { options, context: readContext(options), trigger: document.activeElement, busy: false, uncertain: false, upgraded: false };
    session = current;
    Promise.resolve().then(async () => {
      current.cart = await request('cart.js');
      if (!Array.isArray(current.cart.items) || !Number.isSafeInteger(current.cart.total_price)) throw new Error('cart');
      const matches = current.cart.items.filter(line => String(line.variant_id) === current.context.id);
      current.main = matches.find(line => Object.entries(current.context.properties).every(([key, value]) => String(line.properties?.[key] || '') === String(value)));
      if (!current.main) throw new Error('main');
      current.isPaint = !!current.main.properties?.['Kit Format'] || /touch.?up/i.test(current.main.product_type || config.product.type || config.product.handle);
      current.offers = [];
      await loadStyles();
      if (session !== current) return;
      render(current);
      current.dialog.querySelector('.pf-extras__section-title').textContent = text('loading');
      current.offers = await recommendations(current);
      if (session !== current) return;
      current.dialog.querySelector('.pf-extras__section-title').textContent = text(current.offers.length ? 'optional' : 'empty');
      current.dialog.querySelector('.pf-extras__cards').innerHTML = current.offers.map(item => cardMarkup(item, current)).join('');
      refresh(current);
      track('view', { offers: current.offers.map(item => item.kind).join(','), main_variant_id: current.main.variant_id });
    }).catch(() => { session = null; options.onClose?.(); navigate(root() + 'cart'); });
    return true;
  }

  function init() {
    const ready = () => {
      const data = document.querySelector('[data-addon-styles-config]');
      if (!data) return bootstrap?.loadFailed?.();
      try { config = JSON.parse(data.textContent); } catch (_) { return bootstrap?.loadFailed?.(); }
      const decodedCopy = document.createElement('textarea');
      for (const key of Object.keys(config.copy || {})) {
        decodedCopy.innerHTML = String(config.copy[key] ?? '').replace(/</g, '&lt;');
        config.copy[key] = decodedCopy.value;
      }
      document.documentElement.dataset.partifyAddonStyle = variant;
      window.__partifyAddOnStyles = { active, afterAdd, pending: () => !!session };
      loadStyles();
      const queued = bootstrap?.takePending?.();
      if (queued) afterAdd(queued);
    };
    if (!document.querySelector('[data-addon-styles-config]') && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
    else ready();
  }

  if (!bootstrap) window.__partifyAddOnStyles = { active, afterAdd, pending: () => !!session };
  init();
})();
